module.exports = __webpack_public_path__ + "img/m8.d26bb030.png";